module.exports = __webpack_public_path__ + "static/media/health1.fce8e59e.svg";